// import { createAction } from 'redux-actions';
import { createActions } from 'redux-actions';
import {
  createAsyncActions,
  runAsyncWorkflow
} from '../lib/reduxHelpers';

import { CsfProgram } from '../api';

export const [
    fetchStaticLandingText,
    receiveStaticLandingText,
    staticLandingTextError
  ] = createAsyncActions(
    'STATIC_LANDING_TEXT',
    slug => ({ slug }),
    ({ data }) => ({ data })
  );
  
  export const staticLandingText = ( locale ) => {
    const fetchPromise = CsfProgram.getStaticLandingText( locale );
  
    return runAsyncWorkflow({
        fetch: fetchStaticLandingText,
        receive: receiveStaticLandingText,
        error: staticLandingTextError
      },fetchPromise)
};

export const [
  fetchStaticLessonText,
  receiveStaticLessonText,
  staticLessonTextError
] = createAsyncActions(
  'STATIC_LESSON_TEXT',
  slug => ({ slug }),
  ({ data }) => ({ data })
);

export const staticLessonText = ( locale ) => {
  const fetchPromise = CsfProgram.getStaticLessonText( locale );

  return runAsyncWorkflow({
      fetch: fetchStaticLessonText,
      receive: receiveStaticLessonText,
      error: staticLessonTextError
    },fetchPromise)
};

export const [
  fetchGetProgrammeOverview,
  receiveGetProgrammeOverview,
  getProgrammeOverviewError
] = createAsyncActions(
  'GET_PROGRAMME_OVERVIEW',
  slug => ({ slug }),
  ({ data }) => ({ data })
);

export const getProgrammeOverview = ( locale ) => {
  const fetchPromise = CsfProgram.getProgrammeOverview( locale );

  return runAsyncWorkflow({
      fetch: fetchGetProgrammeOverview,
      receive: receiveGetProgrammeOverview,
      error: getProgrammeOverviewError
    },fetchPromise)
};

export const [
  fetchGetProgrammeOverviewCard,
  receiveGetProgrammeOverviewCard,
  getProgrammeOverviewCardError
] = createAsyncActions(
  'GET_PROGRAMME_OVERVIEW_CARDS',
  slug => ({ slug }),
  ({ data }) => ({ data })
);

export const getProgrammeOverviewCards = (locale ) => {
  const fetchPromise = CsfProgram.getProgrammeOverviewCards(locale);

  return runAsyncWorkflow({
      fetch: fetchGetProgrammeOverviewCard,
      receive:  receiveGetProgrammeOverviewCard,
      error:  getProgrammeOverviewCardError
    },fetchPromise)
};

export const [
  fetchInstructionalRoutines,
  receiveInstructionalRoutines,
  instructionalRoutinesError
] = createAsyncActions(
  'GET_INSTRUCTIONAL_ROUTINES',
  slug => ({ slug }),
  ({ data }) => ({ data })
);

export const getInstructionalRoutines = (locale ) => {
  const fetchPromise = CsfProgram.getInstructionalRoutines(locale);

  return runAsyncWorkflow({
      fetch: fetchInstructionalRoutines,
      receive: receiveInstructionalRoutines,
      error: instructionalRoutinesError
    },fetchPromise)
};

export const [
  fetchGetLevels,
  receiveGetLevels,
  getLevelsError
] = createAsyncActions(
  'GET_LEVELS',
  slug => ({ slug }),
  ({ data }) => ({ data })
);

export const getLevels = (locale) => {
  const fetchPromise = CsfProgram.getLevels(locale);

  return runAsyncWorkflow({
      fetch: fetchGetLevels,
      receive: receiveGetLevels,
      error: getLevelsError
    },fetchPromise)
};

export const [
  fetchGetLevelsFilters,
  recieveGetLevelsFilters,
  getLevelsFiltersError
] = createAsyncActions(
  'GET_LEVEL_FILTERS',
  slug => ({ slug }),
  ({ data }) => ({ filters : data })
);

export const getLevelFilters = (locale) => {
  const fetchPromise = CsfProgram.getLevelFilters(locale);

  return runAsyncWorkflow({
    fetch: fetchGetLevelsFilters,
    receive: recieveGetLevelsFilters,
    error: getLevelsFiltersError
  }, fetchPromise)
}


export const [
  fetchGetRoutineBooks,
  recieveGetRoutineBooks,
  getRoutineBooksError
] = createAsyncActions(
  'GET_FILTERED_RESOURCES',
  () => {},
  ({ ok , data  }) => ({ routineBooks : data.stories })
);

export const getRoutineBooks = (  id , locale) => {
  const fetchPromise = CsfProgram.getRoutineBooks( id , locale );

  return runAsyncWorkflow({
    fetch: fetchGetRoutineBooks,
    receive: recieveGetRoutineBooks,
    error: getRoutineBooksError
  }, fetchPromise)
}


export const [
  fetchCsfBooks,
  receiveCsfBooks,
  fetchCsfBooksError
] = createAsyncActions(
  'FETCH_CSF_BOOKS',
  () => {}, 
  ({ ok , data }) => ({ data: data})
);

export const fetchCsfBooksWorkflow = ( page , filters , routine , locale ) => {
  const fetchPromise = CsfProgram.fetchCsfBooks( page , filters , routine , locale );

  return runAsyncWorkflow(
    {
      fetch: fetchCsfBooks,
      receive: receiveCsfBooks,
      error: fetchCsfBooksError
    },
    fetchPromise
  );
};  

export const [
  fetchCsfGetResourceDetail,
  recieveCsfGetResourceDetail,
  getCsfResourceDetailError
] = createAsyncActions(
  'GET_CSF_RESOURCE_DETAIL',
  ({  bookId , locale  }) => ({  bookId , locale  }),
  ({ data }) => ({ data })
);

export const getResourceDetail = ( bookId , locale ) => {
  const fetchPromise = CsfProgram.getCsfResourceDetails( bookId , locale );

  return runAsyncWorkflow({
    fetch: fetchCsfGetResourceDetail,
    receive: recieveCsfGetResourceDetail,
    error: getCsfResourceDetailError
  }, fetchPromise)
}

export const [
  fetchSimilarBooks,
  recieveSimilarBooks,
  fetchSimilarBooksError
] = createAsyncActions(
  'GET_SIMILAR_BOOKS',
  ({  id  , level , locale  }) => ({  id  , level , locale  }),
  ({ data }) => ({ similarBooks :  data.stories })
);

export const getSimilarBooks = ( id  , level , locale ) => {
  const fetchPromise = CsfProgram.getSimilarBooks( id  , level , locale );

  return runAsyncWorkflow({
    fetch: fetchSimilarBooks,
    receive: recieveSimilarBooks,
    error: fetchSimilarBooksError
  }, fetchPromise)
}



export const [
  postDownload,
  recievePostDownload,
  postDownloadError
] = createAsyncActions(
  'POST_DOWNLOAD',
  ({    user_id , level_number , locale }) => ({  user_id ,  level_number , locale }),
  ({  ok, url}) => ({  ok, url})
);

export const postDownloadWorkflow =  (  user_id , level_number , locale ) => {
  const fetchPromise = CsfProgram.postDownload(   user_id , level_number , locale );

  return runAsyncWorkflow({
    fetch: postDownload,
    receive: recievePostDownload,
    error:   postDownloadError
  }, fetchPromise)
}


export const { addLevelModal } = createActions('ADD_LEVEL_MODAL');
export const { removeLevelModal } = createActions('REMOVE_LEVEL_MODAL');

export const {onTabChange} = createActions('ON_TAB_CHANGE');


// WEBPACK FOOTER //
// ./src/redux/csfActions.js